import { render, staticRenderFns } from "./LootTable.vue?vue&type=template&id=c58b76c6&scoped=true"
import script from "./LootTable.vue?vue&type=script&lang=js"
export * from "./LootTable.vue?vue&type=script&lang=js"
import style0 from "./LootTable.vue?vue&type=style&index=0&id=c58b76c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b76c6",
  null
  
)

export default component.exports